import { request } from './request'

//获取任务详情-数量统计
export interface GetTaskStd {
  id: string
  dept_name: string
  email_type: '1' | '2'
}
export const getTaskStd = (data: GetTaskStd) =>
  request('/portal/verify/phish/campaign/detail/std', {
    params: { ...data },
  })

// 获取任务详情-趋势图-折线图
export interface GetTaskTrend {
  start_time: string
  period: string
  len: string
  campaign_id: string
  dept_name: string
  option?: string
  send_num: number
}
export const getTaskTrend = (data: GetTaskTrend) =>
  request('/portal/verify/phish/campaign/detail/trend', {
    params: data,
  })
// 获取任务详情-趋势图-折线图
export interface GetTaskChartData {
  start_time: string
  period: string
  len: string
  campaign_id: string
  dept_name: string
}
export const getTaskChart = (data: GetTaskChartData) =>
  request('/portal/verify/phish/campaign/detail/chart', {
    params: data,
  })

// 获取任务详情-列表
export interface GetTaskDetailListData {
  campaign_id: string
  keyword?: string
  groupList?: string[]
  dept_name?: string
  aware?: string
  see_through?: number
  limit: number
  page: number
  status?: number
}
export const getTaskDetailList = (data: GetTaskDetailListData) =>
  request('/portal/verify/phish/campaign/detail/list', {
    method: 'post',
    data,
  })
// 任务详情-基础
export interface GetTaskBasic {
  id: string
}
export const getTaskBasic = (data: GetTaskBasic) =>
  request('/portal/verify/phish/campaign/detail/basic', {
    params: data,
  })
// 任务详情-发件日志
export interface GetTaskLog {
  id: string
}
export const getTaskLog = (data: GetTaskLog) =>
  request('/portal/verify/phish/campaign/detail/info', {
    params: data,
  })
// 任务详情 - 详情列表展开
export interface GetDetailEvent {
  campaign_id: string
  email: string
  sid: string
}
export const getDetailEvent = (data: GetDetailEvent) =>
  request('/portal/verify/phish/campaign/detail/event', {
    params: data,
  })
//修改开始时间
export interface UpStart {
  id: string
}
export const upStart = (data: UpStart) =>
  request('/portal/verify/phish/campaign/task/time/start', {
    method: 'PATCH',
    data,
  })
//提交钓鱼识破
export interface GetThrough {
  sid: string
  time: string
}
export const getThrough = (data: GetThrough) =>
  request(`/portal/verify/phish/event/see/through/${data.sid}`, {
    method: 'post',
    data: { time_str: data.time },
  })
//获取部门排名柱状图
export interface GetDept {
  campaign_id: string
  email_type: string
}
export const getDeptAware = (data: GetDept) =>
  request(`/portal/verify/phish/campaign/detail/dept/aware/top`, {
    params: { ...data },
  })

export const getDeptRate = (data: GetDept) =>
  request(`/portal/verify/phish/campaign/detail/dept/rate/top`, {
    params: { ...data },
  })
